#import "../fragments/ContactListFields.graphql"

mutation UpdateContactList($id: ID!, $name: String!) {
  updateContactList(id: $id, name: $name) {
    ...ContactListFields
  }
}
